import moment from 'moment/moment';
import { ChangeEvent, useCallback } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

export type TextInputProps = PropsWithClassName<{
  id?: string;
  name?: string;
  type?: 'date' | 'datetime-local';
  required?: boolean;
  placeholder?: string;
  error?: string;
  value?: string | null;
  onChange?: (value: string) => void;
}>;

export function DateTimeInput({
  type = 'datetime-local',
  name,
  id,
  required,
  placeholder,
  error,
  value,
  onChange,
  className,
}: TextInputProps) {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const valueAsUtcDateTime = moment(event.target.value).utc().format();
      onChange?.(valueAsUtcDateTime);
    },
    [onChange]
  );

  const valueAsLocalDateTime = value ? moment.utc(value).local().format('YYYY-MM-DDTHH:mm') : null;

  return (
    <input
      name={name}
      id={id}
      className={cn(
        'px-3 py-2 border rounded outline-none',
        'disabled:bg-white',
        'focus:border-indigo-500',
        { 'border-red-500': error },
        className
      )}
      onFocus={(event) => event.target.select()}
      // @ts-ignore
      onClick={(event) => event.target.select()}
      type={type}
      required={required}
      placeholder={placeholder}
      value={valueAsLocalDateTime || ''}
      onChange={handleChange}
    />
  );
}
